import SearchResultTypeDocument from './search-result-type-document'
import SearchResultTypeGeneric from './search-result-type-generic'
import SearchResultTypeProduct from './search-result-type-product'
import SearchResultTypeResource from './search-result-type-resource'
import SearchResultTypeVideo from './search-result-type-video'

export default {
    SearchResultTypeDocument,
    SearchResultTypeGeneric,
    SearchResultTypeProduct,
    SearchResultTypeResource,
    SearchResultTypeVideo
}